import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { Form, Col } from '_zari/core'

import TipoDeBusquedaSociosConstant from 'constants/tiposDeBusquedaDeSocios'

const SocioFormGroup = ({ values }) => {
  const __adminContext = React.useContext(AdminContext)

  return (
    <>
      <Form.Group>
        <Form.Label
          text={
            TipoDeBusquedaSociosConstant.__dictionary[
              __adminContext.valoresConfiguracionCompania.tipoBusquedaSocios
            ].nombre
          }
          htmlFor='input-codigoRucSocio'
          md={2}
        />
        <Col md={10}>
          <Form.InputText
            disabled
            id='input-codigoRucSocio'
            defaultValue={
              __adminContext.valoresConfiguracionCompania.tipoBusquedaSocios ===
              TipoDeBusquedaSociosConstant.CODIGO
                ? values.codigoSocio
                : values.documentoSocio
            }
          />
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
